import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/views/Login/index'
import SimpleForm from '@/views/SimpleForm/index'
import Work from '@/views/Work/index'
import NotFound from '@/views/NotFound/index'
import Message from  '@/views/Message/index'
import Mine from  '@/views/Mine/index'
import Home from '@/views/Home/index'
import SJTB from "@/views/SjTb/index";
import sjtbxg from "@/views/SjTb/edit";
import tblist from "@/views/SjTb/tblist";
import Shlist from "@/views/ShenHe/shlist"
import xshtsh from "@/views/ShenHe/xshtsh"
import cghtsh from "@/views/ShenHe/cghtsh"
import yssh from "@/views/ShenHe/yssh"
import hxsh from "@/views/ShenHe/hxsh"
import kpsh from "@/views/ShenHe/kpsh"
import kpsq from "@/views/KaiPiao/index"
import xzhtlist from "@/views/KaiPiao/xzhtlist"
import shlmxc from "@/views/ShenHe/shlmxc"

Vue.use(Router)

const routerPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error=> error)
}

export const constantRoutes = [
  {
    path: '/',
    name: 'login',
    component: Login
  },
  {
    path: '/login',
    name: 'login2',
    component: Login
  },
{
  path:'/simpleform',
  name:'simpleform',
  component:SimpleForm
},
  {
    path: '*',
    component: NotFound
  },
  {
    path: '/index',
    name: 'index',
    component: Home,
    children: [
      // 工作台
      {
        path: '/work',
        name: 'work',
        component: Work,
      },
      // 消息
      {
        path: '/message',
        name: 'message',
        component: Message
      },
      // 我的
      {
        path: '/mine',
        name: 'mine',
        component:Mine
      }
    ]
  },
  {
    path: '/sjtb',
    name: 'sjtb',
    component: SJTB
  },
  {
    path: '/sjxg',
    name: 'sjxg',
    component: sjtbxg
  },
  {
    path: '/tblist',
    name: 'tblist',
    component: tblist
  },
  {
    path: '/shlist',
    name: 'shlist',
    component: Shlist
  },
  {
    path: '/shlmxc',
    name: 'shlmxc',
    component: shlmxc
  },
  {
    path: '/xshtsh',
    name: 'xshtsh',
    component: xshtsh
  },
  {
    path: '/cghtsh',
    name: 'cghtsh',
    component: cghtsh
  },
  {
    path: '/yssh',
    name: 'yssh',
    component: yssh
  },
  {
    path: '/hxsh',
    name: 'hxsh',
    component: hxsh
  },
  {
    path: '/kpsh',
    name: 'kpsh',
    component: kpsh
  },
  {
    path: '/kpsq',
    name: 'kpsq',
    component: kpsq
  },
  {
    path: '/xzhtlist',
    name: 'xzhtlist',
    component: xzhtlist
  },
]
export default new Router({
  // mode: 'history', // 不能设置history模式，ios 版本会有问题
  //base: 'app',
  scrollBehavior: () => ({ y: 0 }),
  routes: constantRoutes
})



// WEBPACK FOOTER //
// ./src/router/index.js